import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";

moment.locale("es");

const corteCajaPdf = (values) => {
    const datosSesion = values.sesion;
    const datosEmpresa = values.empresa;
    const datosCaja = values.caja;
    const datosUsuario = values.usuario;
    const datosVentas = values.ventas;
    const ventasDetalle = values.ventasData;
    const conceptosRetiros = []
    const facturasGlobalesDia = values.facturasGlobalesDia || [];
    const bancosRetirosIngresos = datosSesion?.bancosRetirosIngresos || [];
    let totalIngresos = 0;
    let totalRetiros = 0;

    if (Array.isArray(datosSesion.ingresos)) {
        datosSesion.ingresos.forEach(ingreso => {
            const estaCancelado = ingreso.estado !== 2;
            if (!estaCancelado) {
                totalIngresos += ingreso.monto;
            }
            const bancoAsociado = bancosRetirosIngresos.find(banco => banco?.id?.toString() === ingreso?.bancoId?.toString());
            conceptosRetiros.push([
                {
                    text: bancoAsociado ? `Cuenta: ${bancoAsociado.nombre}` : "Cuenta: N/A",
                    color: estaCancelado ? "#999" : "#000",
                    decoration: estaCancelado ? "lineThrough" : ""
                },
                {
                    text: estaCancelado ? `${ingreso.descripcion} (CANCELADO)` : ingreso.descripcion,
                    color: estaCancelado ? "#999" : "#000",
                    decoration: estaCancelado ? "lineThrough" : ""
                },
                {
                    text: "Ingreso",
                    color: estaCancelado ? "#999" : "#000"
                },
                {
                    text: dineroDisabledMask(ingreso.monto),
                    alignment: "right",
                    color: estaCancelado ? "#999" : "#000",
                    decoration: estaCancelado ? "lineThrough" : ""
                }
            ]);
        });
    }

    if (Array.isArray(datosSesion.retiros)) {
        datosSesion.retiros.forEach(retiro => {
            const estaCancelado = retiro.estado !== 2;
            if (!estaCancelado) {
                totalRetiros += retiro.monto;
            }
            const bancoAsociado = bancosRetirosIngresos.find(banco => banco?.id?.toString() === retiro?.bancoId?.toString());
            conceptosRetiros.push([
                {
                    text: bancoAsociado ? `Cuenta: ${bancoAsociado.nombre}` : "Cuenta: N/A",
                    color: estaCancelado ? "#999" : "#000",
                    decoration: estaCancelado ? "lineThrough" : ""
                },
                {
                    text: estaCancelado ? `${retiro.descripcion} (CANCELADO)` : retiro.descripcion,
                    color: estaCancelado ? "#999" : "#000",
                    decoration: estaCancelado ? "lineThrough" : ""
                },
                {
                    text: "Retiro",
                    color: estaCancelado ? "#999" : "#000"
                },
                {
                    text: dineroDisabledMask(retiro.monto),
                    alignment: "right",
                    color: estaCancelado ? "#999" : "#000",
                    decoration: estaCancelado ? "lineThrough" : ""
                }
            ]);
        });
    }

    // Preparar el detalle de ventas
    const ventasDesglosadas = [];
    if (Array.isArray(ventasDetalle)) {
        ventasDetalle.forEach((venta, index) => {
            const totalPagos = venta.totalPagos || {};
            const estaCancelada = !!venta.cancelada;
            let metodoPagoTexto = [];

            // Construir el texto de métodos de pago
            if (totalPagos.efectivo > 0) {
                metodoPagoTexto.push(`Efe: ${dineroDisabledMask(totalPagos.efectivo)}`);
            }
            if (totalPagos.tarjetaCredito > 0) {
                metodoPagoTexto.push(`TDC: ${dineroDisabledMask(totalPagos.tarjetaCredito)}`);
            }
            if (totalPagos.tarjetaDebito > 0) {
                metodoPagoTexto.push(`TDD: ${dineroDisabledMask(totalPagos.tarjetaDebito)}`);
            }
            if (totalPagos.vales > 0) {
                metodoPagoTexto.push(`Val: ${dineroDisabledMask(totalPagos.vales)}`);
            }
            if (totalPagos.cheque > 0) {
                metodoPagoTexto.push(`Cheq: ${dineroDisabledMask(totalPagos.cheque)}`);
            }
            if (totalPagos.transferencia > 0) {
                metodoPagoTexto.push(`Transf: ${dineroDisabledMask(totalPagos.transferencia)}`);
            }

            const metodoPagoFinal = metodoPagoTexto.join(", ") || "N/A";

            ventasDesglosadas.push([
                {
                    text: venta.folioChico || `V-${index + 1}`,
                    color: estaCancelada ? "#999" : "#000",
                    decoration: estaCancelada ? "lineThrough" : ""
                },
                // moment(venta.fechaRemision || venta.fechaFactura).format("MM/YY HH:mm"),
                {
                    text: estaCancelada ? `${metodoPagoFinal} (CANCELADA)` : metodoPagoFinal,
                    color: estaCancelada ? "#999" : "#000",
                    decoration: estaCancelada ? "lineThrough" : ""
                },
                {
                    text: dineroDisabledMask(venta.totalPagar || 0),
                    alignment: "right",
                    color: estaCancelada ? "#999" : "#000",
                    decoration: estaCancelada ? "lineThrough" : ""
                }
            ]);
        });
    }

    let cancelado = {}
    if (values.estado === 0) {
        cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } }
    }

    var dd = {
        ...cancelado,
        pageSize: 'LETTER',
        pageMargins: [30, 30, 30, 30],
        content: [
            // Encabezado principal
            {
                text: (datosEmpresa.nombreComercial ? datosEmpresa.nombreComercial : datosEmpresa.persona
                    ? datosEmpresa.nombre
                    : datosEmpresa.nombre +
                    " " +
                    datosEmpresa.apellidoPaterno +
                    " " +
                    datosEmpresa.apellidoMaterno),
                style: "empresa",
                alignment: "center",
                margin: [0, 0, 0, 5]
            },

            {
                columns: [
                    { text: "Caja: " + datosCaja.nombre, style: "subheader" },
                    { text: "Usuario: " + (datosUsuario.nombre + " " + datosUsuario.apellidoPaterno + " " + datosUsuario.apellidoMaterno), style: "subheader", alignment: "right" }
                ]
            },
            {
                columns: [
                    { text: "Fecha inicial: " + moment(datosSesion.fechaInicial).format("DD/MM/YYYY HH:mm"), style: "subheader" },
                    { text: "Fecha final: " + moment(datosSesion.fechaFinal).format("DD/MM/YYYY HH:mm"), style: "subheader", alignment: "right" }
                ],
                margin: [0, 0, 0, 5]
            },

            // Layout en dos columnas para optimizar espacio
            {
                columns: [
                    {
                        width: '47.5%',
                        stack: [
                            // Efectivo
                            { text: "Resumen de Efectivo", style: "tableHeader", margin: [0, 5, 0, 2] },
                            {
                                style: "tablaTextoPequeno",
                                table: {
                                    widths: ["*", "auto"],
                                    body: [
                                        ["Saldo Inicial", { text: dineroDisabledMask(datosSesion.saldoInicial), alignment: "right" }],
                                        ["Ventas Efectivo", { text: dineroDisabledMask(datosSesion.totalEfectivo), alignment: "right" }],
                                        ["Ingresos", { text: dineroDisabledMask(totalIngresos), alignment: "right" }],
                                        ["Retiros", { text: "- " + dineroDisabledMask(totalRetiros), alignment: "right" }],
                                        [
                                            { text: "Saldo Final", bold: true },
                                            { text: dineroDisabledMask(datosSesion.saldoFinal || 0), bold: true, alignment: "right" }
                                        ]
                                    ]
                                },
                                layout: "lightHorizontalLines"
                            }
                        ]
                    },
                    {
                        width: '5%',
                        text: '',
                    },
                    {
                        width: '47.5%',
                        stack: [
                            // Ventas
                            { text: "Resumen de Ventas", style: "tableHeader", margin: [0, 5, 0, 2] },
                            {
                                style: "tablaTextoPequeno",
                                table: {
                                    widths: ["*", "auto"],
                                    body: [
                                        ["No. Ventas", { text: datosVentas.count.toString(), alignment: "right" }],
                                        ["Subtotal", { text: dineroDisabledMask(datosVentas.subtotal), alignment: "right" }],
                                        ["Impuestos", { text: dineroDisabledMask(datosVentas.totalImpuestos), alignment: "right" }],
                                        ["Retenciones", { text: "- " + dineroDisabledMask(datosVentas.totalRetenciones), alignment: "right" }],
                                        [
                                            { text: "Total", bold: true },
                                            { text: dineroDisabledMask(datosVentas.totalPagar), bold: true, alignment: "right" }
                                        ]
                                    ]
                                },
                                layout: "lightHorizontalLines"
                            }
                        ]
                    }
                ],
                margin: [0, 0, 0, 5]
            },

            {
                text: "Detalle por Forma de Pago",
                style: "tableHeader",
                margin: [0, 10, 0, 5]
            },
            {
                style: "tablaTextoPequeno",
                table: {
                    widths: ["*", "auto"],
                    body: [
                        ["Forma de Pago", "Monto"],
                        ["Efectivo", { text: dineroDisabledMask(datosSesion.totalEfectivo), alignment: "right" }],
                        ["Vales", { text: dineroDisabledMask(datosSesion.totalVales), alignment: "right" }],
                        ["Cheque", { text: dineroDisabledMask(datosSesion.totalCheque), alignment: "right" }],
                        ["Transferencia", { text: dineroDisabledMask(datosSesion.totalTransferencia), alignment: "right" }],
                        ["Tarjeta", { text: dineroDisabledMask(datosSesion.totalTarjeta), alignment: "right" }]
                    ]
                },
                layout: "lightHorizontalLines"
            },

            // Detalle de Ventas con límite de altura
            { text: "Detalle de Ventas", style: "tableHeader", margin: [0, 5, 0, 2] },
            // Layout en dos columnas para optimizar espacio
            {
                columns: [
                    {
                        width: '47.5%',
                        style: "tablaTextoPequeno",
                        table: {
                            widths: [40, "*", 50],
                            body: [
                                [
                                    { text: "Folio", bold: true },
                                    // { text: "Fecha", bold: true },
                                    { text: "Métodos de Pago", bold: true },
                                    { text: "Total", bold: true, alignment: "right" }
                                ],
                                // Limitar a máximo 15 ventas para que quepa en una página
                                ...ventasDesglosadas.slice(0, ventasDesglosadas.length / 2)
                            ]
                        },
                        layout: "lightHorizontalLines"
                    },
                    {
                        width: '5%',
                        text: '',
                    },
                    {
                        width: '47.5%',
                        style: "tablaTextoPequeno",
                        table: {
                            widths: [40, "*", 50],
                            body: [
                                [
                                    { text: "Folio", bold: true },
                                    // { text: "Fecha", bold: true },
                                    { text: "Métodos de Pago", bold: true },
                                    { text: "Total", bold: true, alignment: "right" }
                                ],
                                // Limitar a máximo 15 ventas para que quepa en una página
                                ...ventasDesglosadas.slice(ventasDesglosadas.length / 2, ventasDesglosadas.length)
                            ]
                        },
                        layout: "lightHorizontalLines"
                    },
                ],
            },

            // Movimientos de caja (solo si hay conceptos)
            ...(conceptosRetiros.length > 0 ? [
                { text: "Movimientos de Caja", style: "tableHeader", margin: [0, 5, 0, 2] },
                {
                    style: "tablaTextoPequeno",
                    table: {
                        widths: ["auto", "*", "auto", "auto"],
                        body: [
                            ["Caja", "Concepto", "Tipo", "Monto"],
                            ...conceptosRetiros.slice(0, 8) // Máximo 8 movimientos
                        ]
                    },
                    layout: "lightHorizontalLines"
                }
            ] : []),

            // Observaciones más compactas
            { text: "Observaciones:", style: "tableHeader", margin: [0, 8, 0, 2] },
            ...(datosSesion.observaciones
                ? [{ text: datosSesion.observaciones, fontSize: 8, margin: [0, 0, 0, 8] }]
                : [
                    { text: "_".repeat(80), margin: [0, 0, 0, 2] },
                    { text: "_".repeat(80), margin: [0, 0, 0, 8] }
                ]),

            // Firmas más compactas
            {
                columns: [
                    { text: "Firma Cajero\n\n___________________", alignment: "center", style: "tablaTextoPequeno" },
                    { text: "Firma Supervisor\n\n___________________", alignment: "center", style: "tablaTextoPequeno" }
                ]
            },
            ...(facturasGlobalesDia.length > 0 ? [
                { text: "Facturas Globales del Día", style: "tableHeader", margin: [0, 8, 0, 2] },
                {
                    style: "tablaTextoPequeno",
                    table: {
                        widths: [60, "*", "*", 55],
                        body: [
                            [
                                { text: "Folio", bold: true },
                                { text: "Fecha", bold: true },
                                { text: "F. de Pago General", bold: true },
                                { text: "Total", bold: true, alignment: "right" }
                            ],
                            ...facturasGlobalesDia.map((fg, i) => ([
                                ((fg.facturaSerie || "FG") + " - " + fg.facturaNumero),
                                moment(fg.fecha || fg.createdAt).format("DD/MM/YYYY HH:mm"),
                                fg?.formaDePagoGeneral?.descripcion || "N/A",
                                { text: dineroDisabledMask(fg.totalPagar || fg.total || 0), alignment: "right" }
                            ]))
                        ]
                    },
                    layout: "lightHorizontalLines"
                }
            ] : []),
        ],
        styles: {
            empresa: {
                fontSize: 14,
                bold: true
            },
            subheader: {
                fontSize: 10,
                margin: [0, 1, 0, 1]
            },
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: "black"
            },
            tablaTextoPequeno: {
                fontSize: 7
            }
        }
    };
    return dd;
};

export default corteCajaPdf;